import UserStore from "./userLocalStorage"

class HandleUtils {

    static generateEmailHatched = (email) => {
        var stringfiedSplit = email ? email.split('@') : ""
        if (stringfiedSplit?.length === 2) {
            var initialEmail = stringfiedSplit[0]
            var domain = stringfiedSplit[1]
            var hatchedEmail = initialEmail.substring(0, 2) + new String('***', initialEmail.length - 2)
            return hatchedEmail + "@" + domain
        } else {
            return email
        }
    }

    static generatePhoneHatched = (phone) => {
        if (!phone) return phone

        // keep only digits
        const digits = phone.replace(/\D/g, '')

        if (digits.length <= 4) {
            return digits
        }

        const lastDigits = digits.slice(-4)
        const maskedPart = '*'.repeat(digits.length - 4)

        return maskedPart + lastDigits
    }

    static getUserInfoByToken = (tokenData) => {
        if (!tokenData) return null
        const tokenParse = JSON.parse(atob(tokenData.split('.')[1]))
        const userInfo = JSON.parse(tokenParse.sub)
        return userInfo
    }

    static getUserInfoByTokenInStorage = () => {
        const tokenData = UserStore.getToken()
        return HandleUtils.getUserInfoByToken(tokenData)
    }
}

export default HandleUtils

